export default __webpack_public_path__ + "static/35(1)-69886c1df21e7bc189546112d0139264.png";